import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Modal, Paragraph, Popover } from '@treams/treams-ui';

// Archives the snapshot; the user-facing copy talks about deleting because
// that is the product term, but nothing is permanently removed.
export default function ArchiveTalentReviewSnapshotModal(props: {
	snapshotID: string;
	onClose: () => void;
	onArchived: () => void;
}) {
	const { t } = useTranslation();
	const [archive, { loading, error }] = graphql.useArchiveTalentReviewSnapshotMutation({
		refetchQueries: ['TalentReviewSnapshots'],
	});

	const handleArchive = async () => {
		try {
			await archive({ variables: { input: { id: props.snapshotID } } });
			props.onArchived();
		} catch {
			// error state is shown via GraphQLErrorMessage
		}
	};

	return (
		<Popover visible center onDismiss={props.onClose}>
			<Modal>
				<Modal.Header title={t('talentReviews.v2.snapshot.delete.title')} onClose={props.onClose} />
				<Modal.Contents>
					<Paragraph>{t('talentReviews.v2.snapshot.delete.body')}</Paragraph>
					{error &&
						(error.graphQLErrors.length ? (
							<GraphQLErrorMessage error={error.graphQLErrors[0]} />
						) : (
							<Paragraph color="danger">{t('talentReviews.v2.saveFailed')}</Paragraph>
						))}
				</Modal.Contents>
				<Modal.Footer>
					<Button
						disabled={loading}
						title={t('talentReviews.v2.cancel')}
						type="secondary"
						onClick={props.onClose}
					/>
					<Button
						loading={loading}
						ml={2}
						title={t('talentReviews.v2.delete')}
						type="destructive"
						disableSuccess
						onClick={handleArchive}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
